import React, {useState}  from 'react'
import {Link} from 'react-router-dom';
import { useProdottiBySottoProdotto } from '../../../components/hooks/hooks-e-commerce/useProdotti';
//import {useScrollToUpperNavBar} from '../../../services/scrollServices';
//import VROne from '../../../images/catalogo/espositore/BottleFourH400.png';
import iconProm from '../../components/images/iconstore/iconPromHW100.png';
import iconSchedaTech from '../../components/images/iconstore/iconSchedaW50.png';
import iconCart from '../../components/images/iconstore/cartW50.png';
//import VRTwo from '../../../images/catalogo/espositore/BottleSixH400.png';
import './expovini.scss';

function ViniRossi() {
//const [isVisible, setIsVisible] = useState(false);
const [hoverStates, setHoverStates] = useState({});
const { prodotti, loading, error/*, count*/ } = useProdottiBySottoProdotto(101);
console.log('in Vini Rossi: ', prodotti);

const elencoProdotti = prodotti.map(elt => ({
    idProdotto: elt.id,
    nome_cantina: elt.nome_cantina,
    nome_vino: elt.nome_vino,
    tipo_vino: elt.tipo_vino,
    vitigni: Object.values(elt.vitigno || {}).filter(Boolean),
    localita_cap: elt.localita_cap,
    provincia: elt.provincia,
    annata: elt.annata,
    gralcol: elt.gradazione_alcolica,
    contenuto_ml: elt.contenuto_ml,
    promo: elt.promo_attiva,
    promoValue: elt.promo_value,
    prezzo: elt.prezzo,
    imgexpo: elt.immagini.imgexpo
}));

// Funzioni per gestire l'hover
const handleMouseEnter = (productId) => {
    setHoverStates(prev => ({
        ...prev,
        [productId]: true
    }));
};

const handleMouseLeave = (productId) => {
    setHoverStates(prev => ({
        ...prev,
        [productId]: false
    }));
};

if (loading) return <div>Caricamento...</div>;
if (error) return <div>Errore: {error}</div>;

    return (
        <section>
            <div className="content-prodotti">
                <div className="grid-bottle">
                    {elencoProdotti.map(item => (
                    <div className="expo-grid__bottle" 
                        onMouseEnter={() => handleMouseEnter(item.idProdotto)} 
                        onMouseLeave={() => handleMouseLeave(item.idProdotto)}
                        key={item.idProdotto}>
                        <div className="expo-bottle">
                            <div className="bottle__infos">
                                <ul>
                                    <li className="info__wine">{item.nome_cantina}</li>
                                    <li className="info__wine" style={{fontWeight: "bold"}}>{item.nome_vino}</li>
                                    <li className="info__wine">{item.tipo_vino}</li>
                                    <li className="info__wine">
                                    {item.vitigni.map((vitigno, index) => (
                                        <span key={index}>
                                            {vitigno}
                                            <br />
                                        </span>
                                        ))}
                                    </li>
                                    <li className="info__wine">{item.localita_cap}</li>
                                    <li className="info__wine">{item.provincia}</li>
                                    <li className="info__wine">{item.annata}</li>
                                    <li className="info__wine">{item.gralcol}</li>
                                    <li className="info__wine">{item.contenuto_ml}</li>
                                    <li className={`info__price ${item.promo ? 'promo' : ''}`}>€ {item.prezzo}</li> 
                                </ul>
                            </div>
                            <div className="bottle__img">
                                <img src={require(`../../../shop/components/images/catalogo/${item.imgexpo}.png`)} alt="" /> 
                            </div>
                        </div>
                        {item.promo && 
                        <div className="bottle__promo">
                            <img src={iconProm} alt="" /><p className="price__info">-{item.promoValue}%</p>
                        </div>}
                        <div className="bottle__price mb-12">
                            <i>Venduto solo in confezioni da <b>N</b> unità</i> 
                            {item.promo ? <p className="price__info">
                            <span>Prezzo all'unità:</span>€ {Math.round((item.prezzo - (item.prezzo * (item.promoValue) * 0.01))*100)/100}
                            </p> : <p className="price__info">
                            <span>Prezzo all'unità:</span>€ {item.prezzo}
                            </p>}
                        </div>
                        {item.idProdotto && <div className={`bottle-infos__links ${hoverStates[item.idProdotto] ? 'visible' : ''}`}>
                            <Link className="link-tech__card" to={`/negozioonline/vini/vinirossi/schedadelvino/${item.idProdotto}`} state={{ scrollToSection: false }}>
                                <img src={iconSchedaTech} alt="" /><p>Scheda tecnica</p>
                            </Link> 
                            <Link className="link-tech__cart mt-12" to={`/negozioonline/vini/vinirossi/schedadelvino/${item.idProdotto}`} state={{ scrollToSection: true }}>
                                <img src={iconCart} alt="" /><p>Aggiungi al carrello</p>
                            </Link>  
                        </div>}  
                    </div>))}
                </div>
            </div>
            {/* <div className="bottom__position" ref={elementRef}></div> */}
        </section>
    )
}
export default ViniRossi;
